import React, { useState, useEffect } from 'react'
import './responsiveNav.css'
import { ModalNavbar } from '../../feedback/modal/ModalNavbar'
import bicepsSvg from '../../../assets/img/biceps-responsive-nav.svg';
import bicepsSvgViolet from '../../../assets/img/biceps-violet.svg'
import { Link, useLocation } from 'react-router-dom';
import { GenericOffCanvas } from '../OffCanvas/GenericOffCanvas';
import { UserLogo } from '../UserLogo/UserLogo';
import { getUserInfo } from './responsiveNavController';
import { fetchTraining } from './responsiveNavController';
import { useToggle } from '../../../context/toggle/toggleBtn';


export const ResponsiveNav = () => {

  const location = useLocation()

  const { toggleBTN, toggleClose, isActive } = useToggle()

  const [memberStatus, setMerberStatus] = useState()
  const [urlService, setUrlService] = useState()

  //? sino existe en localStorage TPATrainingStatus setearlo

  const [refresh, setRefresh] = useState(false)

  const handleRefresh = () => {
    setRefresh(!refresh)
    //console.log('refresh')
  };

  useEffect(() => {

    //console.log('se ejecuta de nuevo')


    const setingUrl = async () => {

      const info = await getUserInfo()

      //console.log('infoSideMenu: ', info)

      if (info && info.data.subscriptions) {

        //console.log('info.data.subscriptions', info.data.subscriptions)
        localStorage.setItem('TPATrainingStatus', info.data.subscriptions.TPATraining)
        setMerberStatus(info.data.subscriptions.TPATraining)


      }

      const TPAmemberStatus = await fetchTraining()

      if (TPAmemberStatus) {
        //console.log('TPAmemberStatus', TPAmemberStatus.data.data.urlService)
        setUrlService(TPAmemberStatus.data.data.urlService)
        setMerberStatus(localStorage.getItem('TPATrainingStatus'))
      }

    }





    setingUrl()

  }, [refresh])



  const [showModal, setshowModal] = useState(false)

  const toggleModal = () => {
    setshowModal(!showModal)
  }


  //? OffCanva menu 

  const [showCanva, setShowCanva] = useState(false)

  const handleShow = () => setShowCanva(!showCanva)

  //? Logo de usuario 



  return (

    <header className="header-nav-responsive responsive-header-class">



      <div className="responsive-user-nav">


        {/* 
                    <Link to="/biblioteca"><i className="bi bi-house-fill bi-house-class"></i></Link>


                    <Link to="/biblioteca"><img className="logo-nav-tpa" src={logoNavBar} alt="logo" /></Link> */}


        <div className='ms-home-container'>

          <Link
            className={`link-responsive-nav ${location.pathname === '/biblioteca' || location.pathname.startsWith('/videos') ? 'selectedBTN' : ''}`}
            to={'./biblioteca'}
            onClick={() => toggleClose()}>
            <span className="material-symbols-outlined ms-size">smart_display</span>
            <p>TPA® Biblioteca</p>
          </Link>

        </div>

        <div className='logo-arm-container'>

          <Link className={`link-responsive-nav ${location.pathname === '/training' ? 'selectedBTN' : ''}`}
            to={`${memberStatus === 'Approved' ? `${urlService}` : '/training'} `}
            target={memberStatus === 'Approved' ? '_blank' : '_self'}
            onClick={() => { handleRefresh(); toggleClose() }}
          >

            <img className="arm-responsive-nav "

              src={location.pathname === '/training' ? bicepsSvgViolet : bicepsSvg}
              //  src={bicepsSvg} 

              alt="" />
            <p>TPA Training®</p>
          </Link>
        </div>


        <Link className={`ms-menu-container link-responsive-nav ${isActive ? 'selectedBTN' : ''}`}


          onClick={() => toggleBTN()}>

          <span className="material-symbols-outlined ms-size" >
            menu
          </span>
          <p>Menú</p>
        </Link>
      </div>


      {/* <GenericOffCanvas showCanva={isActive} handleClose={toggleBTN} UserLogo={UserLogo} /> */}
      <GenericOffCanvas UserLogo={UserLogo} />

      <ModalNavbar showModal={showModal} toggleModal={toggleModal} />
    </header>

  )
}
